import React, { useState, useEffect } from 'react';
import { Timeline } from '../Timeline';

export const FullScreenTimelineModal = ({ 
  currentPolicy, 
  onClose, 
  isOpen,
  initialData,
  initialRelatedPolicies,
  initialSelectedRelationships,
  initialSelectedDepartments,
  initialSelectedMonths,
  initialAllMonths,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const modal = document.getElementById('fullscreen_timeline_modal');
    if (isOpen && modal && !isModalOpen) {
      modal.showModal();
      setIsModalOpen(true);
    }
  }, [isOpen]);

  const handleClose = () => {
    setIsModalOpen(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <dialog id="fullscreen_timeline_modal" className="modal">
      <div className="flex flex-col modal-box p-0 relative w-[90vw] h-[90vh] max-w-[90vw]">
        <div className="bg-white p-4 sticky top-0 z-10">
          <div className="flex justify-between items-center">
            {currentPolicy && (
              <h2 className="card-title pl-4 mr-6">
                【政策时间线分析】- {currentPolicy?.policy_name}
              </h2>
            )}
            <form method="dialog">
              <button 
                className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2 m-1"
                onClick={handleClose}
              >
                ✕
              </button>
            </form>
          </div>
        </div>

        <div className="flex-1 overflow-auto p-2 lg:px-8 lg:py-2">
          <Timeline 
            currentPolicy={currentPolicy} 
            isInModal={true}
            initialData={initialData}
            initialRelatedPolicies={initialRelatedPolicies}
            initialSelectedRelationships={initialSelectedRelationships}
            initialSelectedDepartments={initialSelectedDepartments}
            initialSelectedMonths={initialSelectedMonths}
            initialAllMonths={initialAllMonths}
          />
        </div>
      </div>
      <form method="dialog" className="modal-backdrop">
        <button onClick={handleClose}>close</button>
      </form>
    </dialog>
  );
};